import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";

import PostBoxIcon from "../components/postBox";

import PremiumSparkleIcon from "../../images/premium-sparkle-icon.svg";

const SettingsDeleteAccount = (props) => {



  return (
    <>
          <div className="gitcha-main-wrapper pb-0">
        <div className="content-wrapper h-100">
          <div className="inner-layout-header-new bg-white ">
            <div className="top-three-comp-header w-100 flex-column top-three-comp-headerborder">
              <div className="top-three-comp-header-inner w-100">
                <a className="back-link-btn" href="#">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.1003 5.39972C10.3932 5.69262 10.3932 6.16749 10.1003 6.46038L5.31066 11.2501H20.5C20.9142 11.2501 21.25 11.5858 21.25 12.0001C21.25 12.4143 20.9142 12.7501 20.5 12.7501H5.31066L10.1003 17.5397C10.3932 17.8326 10.3932 18.3075 10.1003 18.6004C9.80744 18.8933 9.33256 18.8933 9.03967 18.6004L2.96967 12.5304C2.82902 12.3897 2.75 12.199 2.75 12.0001C2.75 11.8011 2.82902 11.6104 2.96967 11.4697L9.03967 5.39972C9.33256 5.10683 9.80744 5.10683 10.1003 5.39972Z"
                      fill="#1B1C1E"
                    />
                  </svg>
                </a>
                <div className="heading">Edit Email</div>
                <div class="p-0 toplinks-mobile">
                  <div className="topbar-links notif-delete-btn d-none"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="inner-layout-content-new h-100 ">
            <div className=" h-100  bg-grey-variant">
          
            {/* <div class="no-data d-flex align-items-center justify-content-center flex-column text-center"><h4>You don’t have any favorited want-ads for this client</h4><p class="m-0">Use the Explore tab to browse for want-ads. When you find one you want to favorite, use the Heart icon in the top right corner. </p></div> */}
                <div className="checkEmailWrap">
                <div className="pb-3">
                 
               <h2>Check your email</h2>
               
               <p className="mb-1">We’ve sent a login link to  <a href="#">johnsmith20@gmail.com</a> where you can confirm account deletion. </p>
              
               
                </div>
                <button type="button" className="btn btn-primary w-100 mb-4"   >Open email app</button>
                 <div className="time">Resend <b>59 sec</b></div>
              </div>
              

              
            </div>
          </div>
        </div>
      </div>
     
    </>
  );
};

export default SettingsDeleteAccount;
